---
nb:
  follow_up:
    achived_price: Oppnådd pris
    actual: Faktisk
    buy_production: Kjøp produksjon
    cannibalism: Kannibalisme
    charts:
      capture_rates: Oppnådde rater
      captured_prices: Oppnådde priser
      consumption: Forbruk
      cumulative_production: Kumulativ produksjon
      cumulative_total_revenue: Kumulativ inntekt
      full_load_factor: Fulllastfaktor
      production: Produksjon
      revenue: Inntekt
      revenues_phyiscal_financial: Fysiske og finansielle inntekter
      revenues_variable_fixed: Variable og faste inntekter
      risk_and_cannibalism: Risiko og kannibalisme
      spot_price: Spotpris
      volume: Volum
    consumption: Forbruk
    consumption_tab:
      paid: Betalt
      spot: Spot
    contracted: Kontrahert
    financial: Finansiell
    fixed: Fast
    header: Ytelsesgjennomgang
    hedge: Sikring
    index: Indeks
    merchant: Markedsbasert
    merchant_base_value: Markedsbasert verdi
    net: Nettoverdi
    overproduction: Overproduksjon
    overview:
      actual: Faktisk
      expected: Forventet
      full_load_factor: Fullastfaktor
      hedged_price: Sikret pris
      hedged_volume: Sikret volum
      production: Produksjon
    p50: p50
    physical: Fysisk
    ref: Referanse
    revenues:
      contracted_sales_revenue: Kontrahert salgsinntekt
      fixed_revenues: Fast inntekt
      physical_sales_revenue: Fysisk salgsinntekt
      variable_revenues: Variabel inntekt
    risk:
      overproduction_risk: Overproduksjonsrisiko
      production_shortfall: Underproduksjonsrisiko
    sell_production: Selg produksjon
    shared:
      captured: Oppnådd
      revenue: Inntekt
      total: Total
    shortfall: Manglende
    spot_price: Spotpris
    total: Total
    variable: Variabel
    volume: Volum
